import * as React from 'react';
import './DistributionOptions.scss';
import RadioButton from 'src/components/common/RadioButton';
import Dropdown from 'src/components/common/Dropdown';
import Button from 'src/components/common/Button';

export const SELF_SHIPPING = 'selfShipping';
export const PURCHASE_PREPAID_SHIPPING = 'purchasePrepaidShipping';

interface IShippingOptionsProps {
  distributionSelectedOption: string;
  handleDistributionChangeOption: (e: any) => void;
  rmaSelected: string;
  t?: any;
}

const DistributionOptions: React.FC<IShippingOptionsProps> = props => {
  const {
    rmaSelected,
    distributionSelectedOption,
    handleDistributionChangeOption,
    t
  } = props;

  const getSelectedOption = () => {
    const options = {
      selfShipping: false,
      purchasePrepaidShipping: false
    };

    options[distributionSelectedOption] = true;
    return options;
  };

  const selection = getSelectedOption();

  return (
    <div className="rp-returns-options">
      
      <div className="rp-returns-options-existing">
        <RadioButton
          name={t('myReturns.selfShipping')}
          className="rp-returns-options-radio"
          value={SELF_SHIPPING}
          checked={selection.selfShipping}
          onChange={handleDistributionChangeOption}
        />
      </div>
      <div className="rp-returns-options-new">
        <RadioButton
          name={t('myReturns.purchasePrepaidShipping')}
          className="rp-returns-options-radio"
          value={PURCHASE_PREPAID_SHIPPING}
          checked={selection.purchasePrepaidShipping}
          onChange={handleDistributionChangeOption}
        />
      </div>
    </div>
  );
};

export default DistributionOptions;
